<span matSnackBarLabel>
    {{message}}
</span>
<span matSnackBarActions>
    <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()"><img src="close-icon.svg"></button>
</span>